<template>
    <v-container fill-height>
        <v-layout align-center> 
            <v-flex xs12 sm6 offset-sm3>
                <v-form ref="form1" v-model="valid" :hidden="!showForm" lazy-validation>
                    <v-card>
                        <v-card-title>
                            {{ $t('message.Signin') }}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field autofocus :label="$t('message.FirstName')" v-model="firstName" :error-messages="firstNameErrors" @input="$v.firstName.$touch()" @blur="$v.firstName.$touch()" ></v-text-field>
                            <v-text-field :label="$t('message.LastName')" v-model="lastName" :error-messages="lastNameErrors" @input="$v.lastName.$touch()" @blur="$v.lastName.$touch()" ></v-text-field>
                            <v-text-field :label="$t('message.Username')" v-model="username" :error-messages="usernameErrors" @input="$v.username.$touch()" @blur="$v.username.$touch()" ></v-text-field>
                            <v-text-field :label="$t('message.Password')" type="password" v-model="password" :error-messages="passwordErrors" @input="$v.password.$touch()" @blur="$v.password.$touch()" ></v-text-field>
                            <v-text-field :label="$t('message.PasswordConfirmation')" type="password" v-model="passwordConfirmation"  :error-messages="passwordConfirmationErrors" @input="$v.passwordConfirmation.$touch()" @blur="$v.passwordConfirmation.$touch()"  ></v-text-field>
                            <v-text-field :label="$t('message.Email')" v-model="email"  :error-messages="emailErrors" @input="$v.email.$touch()" @blur="$v.email.$touch()" ></v-text-field>
                            <v-autocomplete  v-model="organizationId" ref="orgText"
                            :items="organizations" 
                            :loading="isLoading" 
                            :search-input.sync="searchOrganizations" 
                            item-text="name" 
                            item-value="id" 
                            :label="$t('message.Organization')" 
                            :no-data-text="$t('message.ajaxAutoComplete')"
                            ></v-autocomplete>
                        </v-card-text>
                        <v-card-actions style="justify-content: space-between;">
                            <router-link to="/account/login" class="login-link"  >{{ $t('message.Login') }}</router-link>
                            <v-btn v-on:click="signin" color="secondary" class="materialized">{{ $t('message.CreateAccount') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
               <div style="margin: 200px auto 0px; width: 400px;" :hidden="showForm" >
                    {{ $t('message.MailHasBeenSent') }}
                    <router-link to="/account/login" class="login-link"  >{{ $t('message.Login') }}</router-link>
                </div>
            </v-flex>
        </v-layout>
         <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import OrganizationRepository from "../../services/OrganizationRepository.js";
import HAL from "../../helpers/HAL.js";
import GenericRepository from "../../services/GenericRepository.js";
import { required,  minLength, sameAs, email } from 'vuelidate/lib/validators'


export default {
    
    name: "AccountCreate",
    data() {
        return {
            valid: true,
            firstName: "",
            lastName: "",
            username: "",
            password: "",
            passwordConfirmation: "",
            email: "",
            organizationId: null,
            organizations: [],
            searchOrganizations: null,
            isLoading: false,
            showmessage: false,
            alertMessage: '',
            showForm: true
        }
    },
    methods: {
        signin() {
            
            if(this.valid) {
                let oName = '';
                for(let i in this.organizations) {
                    if(this.organizations[i].id == this.organizationId) {
                        oName = this.organizations[i].name;
                    }
                }
                let postData = {
                    "firstName": this.firstName,
                    "lastName": this.lastName,
                    "username": this.username,
                    "email": this.email,
                    "password": this.password,
                    "role": this.organizationId <= 0 ? "Admin" : "User",
                    "organization": {
                        "name": oName,
                        "organizationId": this.organizationId <= 0 ? undefined : this.organizationId
                    }
                }
                GenericRepository.insert("/api/registers/member", postData).then(response => {
                    if(response.data.status == 'Success') {
                        this.showForm = false;
                        //window.vm.$router.push('/account/login');
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                });
            }
        }
    },
    created() {
        
    },
    validations: {
        firstName: {
            required
        },
        lastName: {
            required
        },
        username: {
            required,
            regex: /^[a-zA-Z.]*$/,
            minLength: minLength(6)
        },
        password: {
            required,
            minLength: minLength(6)
        },
        passwordConfirmation: {
            required,
            sameAsPassword: sameAs('password')
        },
        email: {
            required,
            email
        },
        organizationId: {
            required
        }
    },
    computed: {
        firstNameErrors() {
            const errors = [];
            if(!this.$v.firstName.$dirty) return errors 
            !this.$v.firstName.required && errors.push(this.$t('message.FirstNameRequired'))
            return errors;
        },
        lastNameErrors() {
            const errors = [];
            if(!this.$v.lastName.$dirty) return errors 
            !this.$v.lastName.required && errors.push(this.$t('message.LastNameRequired'))
            return errors;
        },
        usernameErrors() {
            const errors = [];
            if(!this.$v.username.$dirty) return errors 
            !this.$v.username.regex && errors.push(this.$t('message.UsernameAlphaNum'))
            !this.$v.username.minLength && errors.push(this.$t('message.UsernameBetween'))
            !this.$v.username.required && errors.push(this.$t('message.UsernameRequired'))
            return errors;
        },
        passwordErrors() {
            const errors = [];
            if(!this.$v.password.$dirty) return errors 
            !this.$v.password.minLength && errors.push(this.$t('message.PasswordBetween'))
            !this.$v.password.required && errors.push(this.$t('message.PasswordRequired'))
            return errors;
        },
        passwordConfirmationErrors() {
            const errors = [];
            if(!this.$v.passwordConfirmation.$dirty) return errors 
            !this.$v.passwordConfirmation.sameAsPassword && errors.push(this.$t('message.PasswordConfirmationSameAs'))
            !this.$v.passwordConfirmation.required && errors.push(this.$t('message.PasswordConfirmationRequired'))
            return errors;
        },
        emailErrors() {
            const errors = [];
            if(!this.$v.email.$dirty) return errors 
            !this.$v.email.required && errors.push(this.$t('message.EmailRequired'))
            !this.$v.email.email && errors.push(this.$t('message.EmailFormat'))
            return errors;
        },
        organizationErrors() {
            const errors = [];
            if(!this.$v.organizationId.$dirty) return errors 
            !this.$v.organizationId.required && errors.push(this.$t('message.OrganizationRequired'))
            return errors;
        }
    },
    watch: {
        searchOrganizations(value) {
            if (!value || value.length < 3) return;

            if (this.isLoading) return;

            this.isLoading = true;

            OrganizationRepository.search(value)
            .then(response => {
                this.organizations = HAL.getEmbededResources(
                    response.data,
                    "help:search-organizations"
                );
                if(this.organizations.length == 0) {
                    this.organizations = [ { id: -1 ,  name: value }];
                }
            })
            .finally(() => (this.isLoading = false));
        }
    }

}
</script>

<style scoped>
.login-link {
  text-decoration: none;
  font-weight: bold;
  color: var(--v-primary-base)
}
</style>

